import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HttpClientModule } from '@angular/common/http';

import {AppComponent} from './app.component';
import {APP_ROUTES, DECLARATION_MODULES} from './app.routes';

import { RouterModule } from '@angular/router';

// Servicios
import {NetworkHelperService } from './_services/network-helper.service';

// Plugins
import { DataTablesModule } from 'angular-datatables';
import { Select2Module } from 'ng2-select2';
import { NgxMaskModule } from 'ngx-mask';
import { NgxCurrencyModule } from 'ngx-currency';
import { ImageViewerModule } from '@hallysonh/ngx-imageviewer';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxGalleryModule } from 'ngx-gallery';
import 'hammerjs';
// AuthGuard
import {AuthGuard} from './_guards/auth.guard';
import { DlDateTimePickerDateModule } from 'angular-bootstrap-datetimepicker';
import { MyDatePickerModule } from 'mydatepicker';
import { NotificacionesComponent } from './_components/notificaciones/notificaciones.component';
import { ChatService } from './_services/chat.service';
import { WebsocketService } from './_services/websocket.service';

@NgModule({
    declarations: [
        AppComponent,
        DECLARATION_MODULES,
        NotificacionesComponent
        // PdfViewerComponent
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        FormsModule,
        DataTablesModule,
        Select2Module,
        ImageViewerModule,
        PdfViewerModule,
        NgxGalleryModule,
        DlDateTimePickerDateModule,
        MyDatePickerModule,
        NgxCurrencyModule,
        NgxMaskModule.forRoot(),
        ReactiveFormsModule,
        RouterModule.forRoot(APP_ROUTES, {
            onSameUrlNavigation: 'reload',
            enableTracing: true
          })

    ],
    providers: [
        NetworkHelperService,
        AuthGuard,
        ChatService,
        WebsocketService

    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/app.module.ts